export default __webpack_public_path__ + "5b114ef50ec6bf50ef1ae23c2e3f4694.png";